import { toastService } from "src/libraries/toast";
import { getVacanciesUseCase } from "./getVacanciesUseCase";
import { CreateVacancyDto } from "../entity/vacancies/dto/create-vacancy-dto";
import { vacanciesService } from "../entity/vacancies/VacanciesService";

export const createVacancyUseCase = async (body: CreateVacancyDto) => {
    try {
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image) {
                formData.append('image', body.image, body.image.name)
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        const response = await vacanciesService.create(formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getVacanciesUseCase();
        }
        return response;
    } catch (error) {
        console.warn('createVacancyUseCase: ', error);
    }
}  